// extracted by mini-css-extract-plugin
export default {"msg":"toast_msg__Jdm7Q","fadeInSize":"toast_fadeInSize__l49zO","hiding":"toast_hiding__UpI78"};